import React, { Component } from 'react'
import Button from "reactstrap/es/Button"
import { getLocalData } from "../../../services/StorageServices";
import { parseJwt } from "../../../share/parseToken";
import BulkMarkPackagedModal from './BulkMarkPackagedModal';

class BulkMarkPackaged extends Component {
    state = {
        isOpen: false,
        loading: false
    }

    _handleToggleModal = () => {
        const { resetBulkAll, reloadItems, closeMenu } = this.props
        const { isOpen } = this.state

        this.setState({
            isOpen: !isOpen
        })

        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    render() {
        const { isOpen } = this.state
        const token = getLocalData('accessToken')
        const roles = token !== '' && parseJwt(token).roles ? parseJwt(token).roles : []
        const rolesArr = roles.map(role => {
            return role.name
        })
        const { items = [], selectedItems = [] } = { ...this.props }
        const listItems = items.filter(item => selectedItems.includes(item._id))
        const listItemsDisable = listItems.filter(itemH => (['cancelled', 'cancel-ship', 'packaged'].includes(itemH.production_status)))
        const disabledBtn = listItemsDisable.length > 0

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} className="mr-1" disabled={disabledBtn}>Mark Packaged</Button>
                {isOpen && (
                    <BulkMarkPackagedModal
                        {...this.props}
                        isOpen={isOpen}
                        roles={rolesArr}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkMarkPackaged